import { render, staticRenderFns } from "./excellentcases.vue?vue&type=template&id=48dfff38&scoped=true&"
import script from "./excellentcases.vue?vue&type=script&lang=js&"
export * from "./excellentcases.vue?vue&type=script&lang=js&"
import style0 from "./excellentcases.vue?vue&type=style&index=0&id=48dfff38&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dfff38",
  null
  
)

export default component.exports